import LyQueryInput from './src/main'

LyQueryInput.install = function (Vue) {
    Vue.component(LyQueryInput.name, LyQueryInput)
}

export default LyQueryInput